import * as yup from 'yup';

export const getReleasesFormSchema = () =>
  yup.object().shape({
    description: yup
      .string()
      .max(4000, 'Maximum 4000 characters.')
      .required('Please add a full description !'),
    status: yup.object().nullable().required('Please select a status !'),
    defaultApkFiles: yup
      .array()
      .min(1, 'Please add at least one apk !')
      .required(),
  });
